<template>
  <div style="padding:20px 0 ;">
    <h2 style="font-size: 16px;font-weight: 600;margin: 0 0 10px 0;">公式编辑器</h2>
    <math-field
      id="formula"
      virtual-keyboard-mode="manual"
      style="padding: 1px; margin: 10px ;width:80%;" 
      ></math-field
    >
    <el-button
      type="primary"
      size="small"
      class="btn_css"
      style="margin: 10px 0 0px 0"
      @click="submit_edit"
      id="getLatex"
    >
      确认</el-button
    >
  </div>
</template>
 
<script>
import { MathfieldElement } from "mathlive";
let mf;
export default {
  data() {
    return {
      mathText: "",
    };
  },
  mounted() {
    mf = document.querySelector("#formula");
    const updateLatex = () => {
      this.mathText = mf.value;
    };
    mf.addEventListener("input", updateLatex);
  },

  methods: {
    handleMathInput(value) {
      mf.setValue(value);
      this.mathValue = value;
    },
    submit_edit(){
      this.$emit("math", this.mathText);
    },
  },
};
</script>
 
<style>
.MLK__keycap{
  /* padding: 8px 12px !important; */
  /* line-height: 0.8; */
  /* height: auto !important; */
  display: block;
  /* min-width: 50px; */
  
}
</style>